/** @license See the LICENSE file. */

// This code is auto-generated, do not modify this file!
const version = '3.20.0';
export {version};
